import { html, LitElement, css, unsafeCSS } from 'lit';

import './menu';

import style from './navbar.scss';
import { getUserData, isTouchDevice } from '../shared/utils';

export class NavbarComponent extends LitElement {

    static get properties() {
        return {
            results: { type: Array, state: true }
        }
    }

    constructor() {
        super();
        this.results = [];
        this.menu = false;
        this.userData = null;
        this.loadAvatar();
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    async loadAvatar(){
        const user = await getUserData();
        if(user && user.avatar){
            this.userData = user;
            this.requestUpdate();
        }
    }

    async search(ev) {

        const query = ev.target.value;
        if (!query)
            return;
        let res = await fetch(`./api/search?search=${query}`);
        let json = await res.json();
        this.results = json.results;

    }

    toggleMenu(val) {
        if(!isTouchDevice())
            return;
        const mnu = this.shadowRoot.getElementById('menu');
        this.menu = !this.menu;
        if(typeof val === 'boolean')
            this.menu = val;
        if (this.menu) {
            mnu.style.position = 'absolute';
            mnu.style.top = '55px';
            mnu.style.left = '0px';
            mnu.style.display = 'block';
            mnu.style.height = 'calc(100vh - 70px)';
            mnu.style.overflowY = 'auto';
        } else {
            mnu.style.display = 'none';
        }
    }

    render() {
        return html`
        <nav role="navigation" aria-label="main navigation">
            <div class="navbar-controls">
                <div class="navbar-brand">
                    <a href="./" aria-label="Blightbane.io">
                        <img id="bolgar" class="bolgar" src="../images/bolgar.png" />
                    </a>
                    <a href="./" aria-label="Blightbane.io">
                        <img loading="lazy" src="./images/logo.png" alt="Blightbane.io" />
                    </a>
                    <div>The official resource site for Dawncaster</div>                                
                </div>
            </div>
            <div class="navbar-controls">
                <div class="search" id="menu">
                    <input type="text" placeholder="Search for cards, monsters, events, seeds" 
                        @click=${(ev) => { ev.preventDefault(); ev.stopPropagation(); return false; }}
                        @keyup=${(ev) => this.search(ev)} 
                        @focus=${(ev) => this.search(ev)}  />
                        ${this.results.length > 0 ? html`
                            <div class="results">
                                <div class="rows">
                                ${this.results.map(res => {
                                    if (res.type === 'card')
                                        return html`
                                        <div class="row">
                                            <card-part id="${res.id}"></card-part>
                                        </div>`;
                                    if (res.type === 'talent')
                                        return html`
                                        <div class="row">
                                            <card-part id="${res.id}" talent="true"></card-part>
                                        </div>`;
                                    if (res.type === 'monster')
                                        return html`
                                        <div class="row">
                                            <monster-part id="${res.name}"></monster-part>
                                        </div>`;
                                    if (res.type === 'event')
                                        return html`
                                        <div class="row">
                                            <event-part id="${res.name}"></event-part>
                                        </div>`;
                                    if (res.type === 'seed')
                                        return html`
                                        <div class="row">
                                            🎲 <a href="./seed/${res.name}">${res.name}</a>
                                        </div>`;
                                    })}
                                </div>
                                ${isTouchDevice() ? html`
                                    <div class="close" @click=${() => this.results = []}>Close Search</div>
                                `: ''}
                            </div>
                        `: ''}
                    <menu-component></menu-component>
                </div>
                <div class="button menu" @click=${this.toggleMenu}>
                    Menu
                </div>
                ${this.userData ? html`
                    <a href="./user/${this.userData.username}">
                        <img class="user-img" src="https://cdn.discordapp.com/avatars/${this.userData.id
                        }/${this.userData.avatar}.png" alt="User" />
                    </a>` : 
                    html`
                    <a href="./auth/login" class="discord-login-button">
                        <img src="./images/disc.svg" alt="Discord" />
                    </a>
                    `
                }
                
            </div>
        </nav>        
        `;
    }
}

customElements.define('navbar-component', NavbarComponent);